import React from 'react';
import { useField, useFormikContext } from 'formik';
import { envConfig } from '../../../../utils/config';

interface Option {
  label: string;
  value: string | number;
  disabled?: boolean;
}

interface CustomFormikSelectProps {
  name: string;
  options: Option[];
  className?: string;
  disabled?: boolean;
  isMulti?: boolean;
}

const CustomFormikSelect: React.FC<CustomFormikSelectProps> = ({
  name,
  options,
  className = `form-select-${envConfig.DEFAULT_INPUT_FIELD_SIZE}`,
  disabled = false,
  isMulti = false,
}) => {
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (isMulti) {
      const selectedValues = Array.from(e.target.selectedOptions, (opt) => opt.value);
      setFieldValue(name, selectedValues);
    } else {
      setFieldValue(name, e.target.value);
    }
  };

  return (
    <select
      id={name}
      multiple={isMulti}
      disabled={disabled}
      className={`form-select ${className}`}
      value={field.value}
      onChange={handleChange}
      onBlur={field.onBlur}
    >
      {!isMulti && <option value="">Select</option>}
      {options.map((opt) => (
        <option key={opt.value} value={opt.value} disabled={opt.disabled}>
          {opt.label}
        </option>
      ))}
    </select>
  );
};

export default CustomFormikSelect;
